/** 同URL的临时历史记录，让系统返回先收起聊天，不离开来源业务页。 */
export function createMobileChatHistory(win, onBack) {
  const marker = "__xsouMobileChat";
  const token = `chat_${Date.now()}_${Math.random()}`;
  let url = "",
    pending = null,
    finish = null,
    timer = null;
  const owns = () => win.history.state?.[marker] === token;
  const strip = () => {
    if (!owns()) return;
    const state = { ...win.history.state };
    delete state[marker];
    win.history.replaceState(state, "", win.location.href);
  };
  const settle = () => {
    if (timer) win.clearTimeout(timer);
    timer = null;
    const done = finish;
    finish = null;
    pending = null;
    done?.();
  };
  const pop = () => {
    if (pending) {
      settle();
      return;
    }
    if (url && !owns()) {
      url = "";
      onBack();
    }
  };
  win.addEventListener("popstate", pop);
  return {
    async open() {
      if (pending) await pending;
      url = win.location.href;
      if (owns()) return;
      win.history.pushState({ ...win.history.state, [marker]: token }, "", url);
    },
    close() {
      if (pending) return pending;
      if (!owns() || win.location.href !== url) {
        url = "";
        return Promise.resolve();
      }
      url = "";
      pending = new Promise((resolve) => {
        finish = resolve;
      });
      const result = pending;
      // 某些嵌入式浏览器不派发popstate；回退只清掉当前标记。
      timer = win.setTimeout(() => {
        strip();
        settle();
      }, 500);
      win.history.back();
      return result;
    },
    dispose() {
      strip();
      url = "";
      settle();
      win.removeEventListener("popstate", pop);
    },
  };
}
